<template>
  <div v-if="areDetailsShown" class="logLinksContainer">
    <LoggerLink
      v-if="intentAnalysed && intentAnalysed.intentName"
      :is-custom="isCustomIntent"
      :name="intentName"
      :url="intentUrl"
      :is-hovered="isHovered"
      @openUrl="openUrl"
    />
    <LoggerLink
      v-else-if="actionDeduced && actionDeduced.action"
      :is-custom="isCustomAction"
      :name="actionName"
      :url="actionUrl"
      :is-hovered="isHovered"
      @openUrl="openUrl"
    />
    <p v-if="intentAnalysed && intentAnalysed.intentDetectionConfidence === 0">{{ $t('no_intent_label') }}</p>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import LoggerLink from './LoggerLink'
import config from '../../config'

export default {
  name: 'LoggerLinks',
  components: {
    LoggerLink
  },
  props: {
    intentAnalysed: { type: Object, default: null },
    isHovered: { type: Boolean, required: false },
    actionDeduced: { type: Object, default: null },
    assistantId: { type: String, required: true },
    assistantSlug: { type: String, required: true },
    areDetailsShown: { type: Boolean, required: true }
  },
  computed: {
    ...mapGetters({
      locale: 'locale'
    }),
    isCustomAction() {
      return this.actionDeduced && !this.actionDeduced.masterActionId
    },
    isCustomIntent() {
      return this.intentAnalysed && this.intentAnalysed.intentName && !this.intentAnalysed.intentMasterId
    },
    baseUrl() {
      return this.getBaseUrl(this.assistantId, this.assistantSlug)
    },
    actionUrl() {
      return this.actionDeduced && this.actionDeduced.actionId && this.actionDeduced.action
        ? `${this.baseUrl}/flows/${this.actionDeduced.actionId}/${this.actionDeduced.action}`
        : null
    },
    intentUrl() {
      return this.isCustomIntent ? `${this.baseUrl}/flows/intents/${this.intentAnalysed.intentName}` : null
    },
    actionName() {
      return this.getLocalizedName(this.actionDeduced.localizedNames, this.actionDeduced.action, this.locale)
    },
    intentName() {
      return this.getLocalizedName(this.intentAnalysed.localizedNames, this.intentAnalysed.intentName, this.locale)
    }
  },
  methods: {
    openUrl(url) {
      this.$emit('openUrl', url)
    },
    getLocalizedName(localizedNames, slug, locale) {
      if (!localizedNames || !localizedNames.length) {
        return slug
      }
      const localizedNameObj = localizedNames.find(localizedName => localizedName.locale === locale)
      return (localizedNameObj && localizedNameObj.name) || slug
    },
    getBaseUrl(assistantId, assistantSlug) {
      const displayId = assistantId.slice(-config.ASSISTANT_DISPLAY_ID_LENGTH)
      return `/${displayId}/${assistantSlug}`
    }
  }
}
</script>
